import { configureStore } from "@reduxjs/toolkit";
import productReducer from "../features/product/redux/ProductList.slice";
import productDetailsReducer from "../features/ProductDetail/redux/productDetailsSlice";
import cartReducer from "../features/cart/redux/cartSlice";
import summaryReducer from "../features/checkout/redux/summarySlice";

export const store = configureStore({
  reducer: {
   product: productReducer,
   productDetails: productDetailsReducer,
   cart: cartReducer,
   summary: summaryReducer,
  },
});
export default store;